import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  location: 'Summerlin, NV',
  text: "Caballero's Electric was fantastic. We had a partial power outage and they sent someone out within 2 hours. The electrician was professional and fixed it for exactly what they quoted.",
  rating: 5,
  photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Michael T.',
  location: 'Henderson, NV',
  text: 'I hired them to upgrade my electrical panel and install an EV charger. The work was incredibly clean, they handled all the permits, and the inspector commented on how well the job was done.',
  rating: 5,
  photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'David R.',
  location: 'Las Vegas, NV',
  text: "As a restaurant owner, electrical issues mean lost revenue. When our cooler circuit kept tripping, Caballero's came out on a Sunday night and got us back up and running. Lifesavers!",
  rating: 5,
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80'
}];
export function Testimonials() {
  return <section id="reviews" className="py-24 bg-[#1f1f1f] relative overflow-hidden" data-id="element-169">
      {/* Background image with heavy overlay for texture */}
      <div className="absolute inset-0 z-0" data-id="element-170">
        <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=60" alt="" className="w-full h-full object-cover" data-id="element-171" />
        <div className="absolute inset-0 bg-[#1f1f1f]/95" data-id="element-172" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase" data-id="element-175">
            TRUSTED BY <span className="text-[#FFD700]" data-id="element-176">NEVADA</span> HOMEOWNERS
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-177">
            Don't just take our word for it. See what our customers have to say
            about our service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#2d2d2d] p-8 rounded-3xl border border-[#3a3a3a] relative" data-id="element-179">
              <Quote className="absolute top-8 right-8 w-10 h-10 text-[#3a3a3a]" data-id="element-180" />

              <div className="flex gap-1 mb-6" data-id="element-181">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-182" />)}
              </div>

              <p className="text-gray-300 mb-8 relative z-10 leading-relaxed italic" data-id="element-183">
                "{testimonial.text}"
              </p>

              <div className="mt-auto flex items-center gap-4" data-id="element-184">
                <img src={testimonial.photo} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#FFD700]" data-id="element-185" />
                <div data-id="element-186">
                  <div className="font-bold text-white uppercase tracking-wide" data-id="element-187">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-400" data-id="element-188">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}